export class NetworkError extends Error {
  constructor(url: string) {
    super(`Other network error. Could not send request to: ${url}`);
    this.name = 'NetworkError';
  }
}
